/* Small site-wide enhancements, loaded on every page from snippets/snacc-cart-drawer.liquid. */

/* Product page gallery (01 Gallery).
   - The round "Front / Back / Photo 3" capsules under the main image show the photo they open (styling in snacc-touch.css).
   - Tapping a thumbnail glides the main image to that photo with an eased animation, and the highlight moves straight
     to the tapped thumbnail. The page's own handler set the highlight first and then let the scroll position pull it back
     while scrolling, which made the thumbnails jump back and forth; this replaces that handler for thumbnail taps.
   - Swiping the main image still works and the highlight follows the photo in view.
   - The thumbnails are on their own line under the image (snacc-touch.css); if that line scrolls, it follows the selection. */
(function () {
  var ROW = '[data-screen-label="01 Gallery"] div:has(> button):not(:has(> :not(button)))';
  var style = null, last = '', target = -1, anim = 0, bound = null, glides = 0;

  function parts() {
    var sec = document.querySelector('[data-screen-label="01 Gallery"]');
    if (!sec) return null;
    var slider = sec.querySelector('div[role="img"]');
    slider = slider && slider.parentElement && slider.parentElement.parentElement;
    var row = sec.querySelector('div:has(> button):not(:has(> :not(button)))');
    return slider && row ? { sec: sec, slider: slider, row: row } : null;
  }
  function current(p) {
    if (target >= 0) return target;
    return Math.round(p.slider.scrollLeft / Math.max(1, p.slider.clientWidth));
  }
  function render() {
    var p = parts(); if (!p) return;
    if (bound !== p.slider) { bound = p.slider; p.slider.addEventListener('scroll', render, { passive: true }); }
    var slides = p.sec.querySelectorAll('div[role="img"]'), css = '';
    for (var i = 0; i < slides.length; i++) {
      var bg = slides[i].style.backgroundImage;
      if (bg && bg !== 'none') css += ROW + ' > button:nth-child(' + (i + 1) + '){background-image:' + bg + ' !important}\n';
    }
    css += ROW + ' > button:nth-child(' + (current(p) + 1) + '){outline-color:#FDB716 !important;transform:translateY(-3px) !important;box-shadow:-3px 3px 0 #1E1C1A !important}\n';
    if (css === last) return;
    last = css;
    if (!style) { style = document.createElement('style'); style.id = 'snacc-gallery-thumbs'; document.head.appendChild(style); }
    style.textContent = css;
    /* Keep the selected thumbnail in view when the thumbnail line is wider than the screen (scrolls the line only). */
    var sel = p.row.children[current(p)];
    if (sel && p.row.scrollWidth > p.row.clientWidth + 1) {
      var to = sel.offsetLeft - (p.row.clientWidth - sel.offsetWidth) / 2;
      to = Math.max(0, Math.min(to, p.row.scrollWidth - p.row.clientWidth));
      if (Math.abs(p.row.scrollLeft - to) > 2) p.row.scrollTo({ left: to, behavior: 'smooth' });
    }
  }
  /* Snap is switched off with a stylesheet rule (not the element's own style, which the page rewrites) while gliding. */
  var snapStyle = null;
  function snapOff(on) {
    if (!snapStyle) { snapStyle = document.createElement('style'); document.head.appendChild(snapStyle); }
    snapStyle.textContent = on ? '[data-screen-label="01 Gallery"] div:has(> div > div[role="img"]){scroll-snap-type:none !important}' : '';
  }
  function glide(slider, to) {
    cancelAnimationFrame(anim);
    var from = slider.scrollLeft, d = to - from, t0 = null, dur = Math.min(650, 380 + Math.abs(d) * 0.25);
    snapOff(true);
    function step(t) {
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / dur), e = k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
      slider.scrollLeft = from + d * e;
      if (k < 1) { anim = requestAnimationFrame(step); return; }
      snapOff(false);
      target = -1; render();
    }
    anim = requestAnimationFrame(step);
    /* Safety net: if the browser holds back animation frames (background tab, low-power mode), land on the photo anyway.
       Only the latest glide does this, so quick repeat taps don't fight. */
    var mine = ++glides;
    setTimeout(function () {
      if (mine !== glides || Math.abs(slider.scrollLeft - to) < 2) return;
      cancelAnimationFrame(anim); slider.scrollLeft = to; snapOff(false); target = -1; render();
    }, dur + 400);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(ROW + ' > button');
    if (!btn) return;
    var p = parts(); if (!p) return;
    e.stopPropagation(); e.preventDefault();
    var i = Array.prototype.indexOf.call(btn.parentNode.children, btn);
    target = i; render();
    glide(p.slider, i * p.slider.clientWidth);
  }, true);

  /* The main photo follows the pack picked under "Pick your pack": it glides to the selected variant's own image in
     Shopify admin (Composite Jar, Pillow Pouch 6 g / 21 g, ...). A pack without its own image (the Standy) goes back
     to photo 1. The page writes the picked variant into the address (?variant=), which is what this watches. */
  var products = {}, seen = ''; // empty, so a page opened on ?variant= also starts on that pack's photo
  function followVariant() {
    var key = location.pathname + location.search;
    if (key === seen) return;
    seen = key;
    var m = /[?&]variant=(\d+)/.exec(location.search), path = location.pathname;
    if (!m || !/^\/products\//.test(path)) return;
    var show = function (pos) {
      if (pos == null || location.pathname !== path) return;
      var p = parts(); if (!p) return;
      var i = pos > 0 ? pos - 1 : 0;
      if (i >= p.sec.querySelectorAll('div[role="img"]').length) i = 0;
      if (Math.round(p.slider.scrollLeft / Math.max(1, p.slider.clientWidth)) === i) return;
      target = i; render();
      glide(p.slider, i * p.slider.clientWidth);
    };
    /* Positions come from snippets/snacc-cart-drawer.liquid for the product the page opened on; for another product
       (the flavour switcher) they are read from the product's data. */
    var handle = decodeURIComponent(path.split('/products/')[1].split('/')[0]), known = (window.SnaccVariantImagePos || {})[handle];
    if (known && m[1] in known) return show(known[m[1]]);
    var fromProduct = function (prod) {
      var v = (prod.variants || []).filter(function (x) { return String(x.id) === m[1]; })[0];
      return v ? (v.featured_image && v.featured_image.position) || 0 : null;
    };
    if (products[path]) return show(fromProduct(products[path]));
    fetch(path + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (prod) { products[path] = prod; show(fromProduct(prod)); }, function () {});
  }

  function start() { render(); setInterval(render, 600); setInterval(followVariant, 250); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Product cards on the home and collection pages: the whole card opens the product page, not just its name.
   Buttons and links inside the card (Pack pills, "snacc IT +", the name) keep doing their own thing. The photo no
   longer flips to a second picture (assets/snacc-reference-home.js and snacc-collection.js). */
(function () {
  var CARD = '[data-screen-label] article:has(h3 a[href*="/products/"])';
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target;
    if (!t.closest || t.closest('a, button, input, select, textarea, label, [role="button"]')) return;
    var card = t.closest(CARD);
    if (!card) return;
    var sel = window.getSelection && window.getSelection();
    if (sel && String(sel).length) return;
    var a = card.querySelector('h3 a[href*="/products/"]');
    if (a) window.location.href = a.href;
  });
  var css = document.createElement('style');
  css.textContent = CARD + '{cursor:pointer}[data-snacc-no-hint]{display:none !important}';
  (document.head || document.documentElement).appendChild(css);
  /* The photo's corner sticker said "flip it"; with no flip it is drawn empty, so hide it (CSS :empty can't see it). */
  function hideEmpty() {
    var s = document.querySelectorAll('[data-screen-label] article div[role="img"] ~ span:not([data-snacc-no-hint])');
    for (var i = 0; i < s.length; i++) if (!s[i].textContent.trim()) s[i].setAttribute('data-snacc-no-hint', '');
  }
  setInterval(hideEmpty, 500);
})();

/* Footer, every page: a second company address (the Nawanshahr unit) under the New Delhi one, in the same style.
   Footers are drawn three ways, so each is handled:
   - the address is real text (home, About, collection on desktop, and snippets/snacc-footer.liquid on all other pages):
     the new block goes right after it, copying its look;
   - the address is drawn by snacc-touch.css (product pages, collection on phones): the new block goes at the top of the
     element that stylesheet writes the address into, so it sits directly under it.
   Pages redraw their footers, so this re-checks and re-adds it when needed. */
(function () {
  var NAME = 'M/s. Aroson Foods Pvt Ltd';
  var ADDR = 'Khasra No.797, Ludhiana Road, Near Market Committee Nawanshahr, Punjab - 144514';
  function make(tag, cls, style, nameStyle) {
    var el = document.createElement(tag);
    el.className = 'snacc-addr2' + (cls ? ' ' + cls : '');
    if (style) el.setAttribute('style', style);
    var b = document.createElement(nameStyle === 'strong' ? 'strong' : 'span');
    if (nameStyle && nameStyle !== 'strong') b.setAttribute('style', nameStyle);
    b.textContent = NAME;
    el.appendChild(b); el.appendChild(document.createElement('br')); el.appendChild(document.createTextNode(ADDR));
    return el;
  }
  function textHost(f) {
    var w = document.createTreeWalker(f, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) if (/Arjun Nagar/.test(n.data)) return n.parentElement;
    return null;
  }
  function add() {
    var fs = document.querySelectorAll('footer:not([class*="cart"])');
    for (var i = 0; i < fs.length; i++) {
      var f = fs[i];
      if (f.querySelector('.snacc-addr2')) continue;
      var host = textHost(f);
      if (host && host.classList.contains('snacc-footer__company')) {
        host.parentNode.insertBefore(make('span', 'snacc-footer__company', '', 'strong'), host.nextSibling);
      } else if (host) {
        var name = host.querySelector('span'), st = (host.getAttribute('style') || '').replace(/border-top:[^;]*;?/g, '').replace(/padding-top:[^;]*;?/g, '');
        host.parentNode.insertBefore(make('div', '', st + ';padding-top:8px', name ? name.getAttribute('style') : 'font-weight:800'), host.nextSibling);
      } else {
        var holder = f.querySelector(':scope > div:last-of-type > div:first-child');
        if (holder && /Arjun/.test(getComputedStyle(holder, '::before').content || '')) {
          holder.insertBefore(make('div', '', 'margin-bottom:12px;color:#D9D1C4', 'font-weight:800;color:#FEF7EB'), holder.firstChild);
        }
      }
    }
  }
  function start() { add(); setInterval(add, 500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* "Shop all" / "View all" links on the home and product pages pointed at the bestsellers strip (#bestsellers),
   so they never reached the full range. Send them to the collection page instead, and fix the link address too
   so long-press / open-in-new-tab also go there. */
(function () {
  var SHOP = '/collections/all';
  function isShopAll(a) {
    if (!a || a.tagName !== 'A') return false;
    var t = (a.textContent || '').trim().toLowerCase(), h = a.getAttribute('href') || '';
    return (t === 'shop all' || t === 'view all') && /(^|\/)#bestsellers$/.test(h);
  }
  function fixLinks() {
    var links = document.querySelectorAll('a[href$="#bestsellers"]');
    for (var i = 0; i < links.length; i++) if (isShopAll(links[i])) links[i].setAttribute('href', SHOP);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a');
    if (!a) return;
    var t = (a.textContent || '').trim().toLowerCase();
    if ((t === 'shop all' || t === 'view all') && /(^|\/)#bestsellers$|\/collections\/all$/.test(a.getAttribute('href') || '')) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault(); e.stopPropagation();
      window.location.href = SHOP;
    }
  }, true);
  function start() { fixLinks(); setInterval(fixLinks, 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* "FAQs" footer links. They pointed at #snacc-faq, which no page had, so they went nowhere. Now the FAQ section on the
   page in view gets that id (home: "12 FAQ", collection pages: "04 FAQ"): on the home and collection pages the link
   scrolls to their own FAQs, and from the About page it opens the home page FAQs. Product pages keep their own
   #pdp-faq link. The FAQ section is drawn by the page script, so arriving at /#snacc-faq waits for it, then scrolls. */
(function () {
  var ID = 'snacc-faq';
  function faq() {
    var all = document.querySelectorAll('section[data-screen-label$=" FAQ"]:not(#pdp-faq)');
    for (var i = 0; i < all.length; i++) if (all[i].offsetParent) return all[i];
    return null;
  }
  function mark() {
    var f = faq(), old = document.getElementById(ID);
    if (old && old !== f && old.tagName === 'SECTION') old.removeAttribute('id');
    if (f && f.id !== ID) { f.id = ID; f.style.scrollMarginTop = '86px'; }
    var links = document.querySelectorAll('a[href$="#' + ID + '"]');
    for (var i = 0; i < links.length; i++) {
      var want = f ? '#' + ID : '/#' + ID;
      if (links[i].getAttribute('href') !== want) links[i].setAttribute('href', want);
    }
    return f;
  }
  function go(f) { f.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#' + ID + '"]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var f = mark();
    if (!f) return; // no FAQ here: the link goes to the home page FAQs
    e.preventDefault();
    if (history.replaceState) history.replaceState(null, '', '#' + ID);
    go(f);
  }, true);
  function start() {
    mark(); setInterval(mark, 1000);
    if (location.hash === '#' + ID) {
      var tries = 0, t = setInterval(function () {
        var f = mark();
        if (f || ++tries > 40) { clearInterval(t); if (f) setTimeout(function () { go(f); }, 150); }
      }, 150);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Product page "Watch before you buy" (08 Watch): shows the same Instagram reels as the home page, in a different
   order, with the same product card under each reel (photo, name, price, "snacc +"). Reels and order are set in
   snippets/snacc-reels-data.liquid. The product page's own poster cards are hidden by snacc-touch.css. */
(function () {
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function embed(link) { var m = /instagram\.com\/(?:reel|p)\/([^/?#]+)/.exec(link || ''); return m ? 'https://www.instagram.com/reel/' + m[1] + '/embed/' : ''; }
  var BTN = 'position:relative;overflow:hidden;-webkit-mask:radial-gradient(circle 8px at calc(100% - 34px) -3px,transparent 7.5px,#000 8px);mask:radial-gradient(circle 8px at calc(100% - 34px) -3px,transparent 7.5px,#000 8px)';
  var BITE = '<span style="position:absolute;pointer-events:none;width:30px;height:30px;left:calc(100% - 49px);top:-18px;border-radius:50%;background:radial-gradient(circle closest-side,transparent 7.5px,#1E1C1A 8px,#1E1C1A 9.5px,#FEF7EB 9.5px,#FEF7EB 12px,#FDB716 12px,#FDB716 14.5px,transparent 15px)"></span><span style="position:absolute;pointer-events:none;width:5px;height:5px;border-radius:50%;background:#FDB716;left:calc(100% - 46px);top:8px"></span><span style="position:absolute;pointer-events:none;width:3px;height:3px;border-radius:50%;background:#FEF7EB;left:calc(100% - 24px);top:10px"></span>';
  function build(sec) {
    var R = window.SnaccReelsPdp;
    if (!R || !R.length || sec.querySelector(':scope > .snacc-reels')) return;
    var html = R.map(function (r, i) {
      var src = embed(r.link);
      return '<div class="snacc-reel">' +
        '<div class="snacc-reel__media">' + (src ? '<iframe src="' + esc(src) + '" title="' + esc(r.name) + ' reel" loading="lazy" scrolling="no" allow="autoplay; encrypted-media; picture-in-picture; clipboard-write"></iframe>' : '') +
        '<span class="snacc-reel__tag">' + esc(r.caption) + '</span></div>' +
        '<div class="snacc-reel__card" data-url="' + esc(r.url) + '">' +
        '<span class="snacc-reel__thumb" style="background-image:url(\'' + esc(r.img) + '\')"></span>' +
        '<div class="snacc-reel__info"><div class="snacc-reel__name">' + esc(r.name) + '</div><div class="snacc-reel__price">' + esc(r.price) + '</div></div>' +
        '<button type="button" class="snacc-reel__add" data-variant="' + esc(r.variant) + '" aria-label="Add ' + esc(r.name) + ' to snacc bag" style="' + BTN + '"' + (r.available ? '' : ' disabled') + '>' + BITE + '<span class="snacc-reel__label">' + (r.available ? 'snacc +' : 'sold out') + '</span></button>' +
        '</div></div>';
    }).join('');
    var wrap = document.createElement('div');
    wrap.className = 'snacc-reels';
    wrap.innerHTML = html;
    sec.appendChild(wrap);
  }
  function tick() { document.querySelectorAll('[data-screen-label="08 Watch"]').forEach(build); }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var btn = t.closest('.snacc-reel__add');
    if (btn) {
      e.preventDefault();
      if (btn.disabled) return;
      var label = btn.querySelector('.snacc-reel__label');
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant')), quantity: 1 }] }) })
        .then(function (r) {
          if (!r.ok) throw new Error();
          label.textContent = 'added ✓';
          if (window.SnaccCart && window.SnaccCart.open) window.SnaccCart.open();
          /* Send the fresh cart with the event: the product page header only updates its bag count from event.detail.cart. */
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (c) { return c.json(); })
            .then(function (cart) { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } })); },
                  function () { document.dispatchEvent(new CustomEvent('cart:updated')); });
        })
        .catch(function () { label.textContent = 'try again'; })
        .then(function () { setTimeout(function () { label.textContent = 'snacc +'; btn.disabled = false; }, 1600); });
      return;
    }
    var card = t.closest('.snacc-reel__card');
    if (card && card.getAttribute('data-url')) window.location.href = card.getAttribute('data-url');
  });
  function start() { tick(); setInterval(tick, 800); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* About page "Snaccers, first." (05 The people): photos on the polaroid cards, matched by the name on the card.
   Same four photos and order as the home page's generations card (home page settings: Generation 1 to 4).
   The Shrey card shows Shrey's photo; the four generations card steps through gen 1, gen 2, gen 3 and Shrey Arora
   (the stepping is in assets/snacc-about.js). Styling in snacc-touch.css. */
(function () {
  var F = 'https://cdn.shopify.com/s/files/1/0759/9570/9681/files/';
  var GEN = [F + 'WhatsApp_Image_2026-10-14_at_3.35.36_PM.jpg?v=1791972519', F + 'WhatsApp_Image_2026-10-14_at_3.35.37_PM_1.jpg?v=1791972520',
    F + 'WhatsApp_Image_2026-10-14_at_3.35.37_PM.jpg?v=1791972520', F + 'WhatsApp_Image_2026-10-14_at_3.35.37_PM_2.jpg?v=1791972520'];
  var BY_NAME = { 'gen 1': 0, 'gen 2': 1, 'gen 3': 2, 'shrey arora': 3, 'shrey': 3 };
  var preloaded = false;
  function tick() {
    var cards = document.querySelectorAll('[data-screen-label="05 The people"] > div:nth-child(2) > div');
    if (!cards.length) return;
    if (!preloaded) { preloaded = true; GEN.forEach(function (u) { var i = new Image(); i.src = u + '&width=600'; }); }
    for (var c = 0; c < cards.length; c++) {
      var slot = cards[c].children[1], nameEl = cards[c].children[2];
      if (!slot || !nameEl) continue;
      var name = (nameEl.textContent || '').trim(), k = BY_NAME[name.toLowerCase()];
      if (k == null) continue;
      var img = slot.querySelector('img[data-snacc-gen]');
      if (!img) { img = document.createElement('img'); img.setAttribute('data-snacc-gen', ''); img.setAttribute('loading', 'lazy'); slot.appendChild(img); }
      var src = GEN[k] + '&width=600';
      if (img.getAttribute('src') !== src) { img.setAttribute('src', src); img.setAttribute('alt', name); }
    }
  }
  function start() { tick(); setInterval(tick, 250); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Product page "Pick your pack" (02 Buy box).
   1. Pack names: the cards, the pack summary line and the cards' screen-reader labels say Composite Jar, Standy and
      Pillow Pouch (the same names as the Pack Size option in Shopify admin). The page's own code still uses its
      original short names internally; they are swapped the moment the page draws them, so they never show.
   2. Pack photos: each card shows the real pack photo of the product on screen in place of the drawn pack.
      Photos: assets/snacc-jar-<key>.webp (Composite Jar), snacc-pouch-<key>.webp (Standy) and snacc-pillow-<key>.webp
      (Pillow Pouch). The product is read from the product name, so it follows the flavour picker too. Products
      without a photo keep the drawing.
      Pillow Pouches come in two looks: the small pillow pack (6 g, the makhana flavours) and the long bar pack (15 g,
      the dry fruits). The 21 g makhana Pillow Pouch uses its variant image from Shopify admin. The 21 g makhana pack is a Standy and shows the Standy photo. The Pillow Pouch card shows the
      photo of the size that is selected (or, before Pillow Pouch is picked, the first size on the card).
      Styling in snacc-touch.css. */
(function () {
  var me = document.currentScript && document.currentScript.src;
  var BASE = me ? me.replace(/snacc-enhance\.js.*$/, '') : '';
  var V = me && /[?&]v=(\d+)/.exec(me) ? '?v=' + /[?&]v=(\d+)/.exec(me)[1] : '';
  // [name the page's code uses, name shown]
  var NAMES = [['Jar', 'Composite Jar'], ['Pouch', 'Standy'], ['Sachet', 'Pillow Pouch']];
  var MAKHANA = ['bbq', 'hsp', 'italian', 'peri', 'pudina'];
  var PHOTOS = [
    { name: 'Composite Jar', prefix: 'snacc-jar-', keys: MAKHANA },
    { name: 'Standy', prefix: 'snacc-pouch-', keys: MAKHANA.concat(['almond-salted', 'almond-tandoori', 'cashew-salted', 'cashew-peri', 'cashew-italian', 'trail']) },
    // keys: 6 g pillow pack photos. big: 15 g bar pack photos.
    { name: 'Pillow Pouch', prefix: 'snacc-pillow-', keys: MAKHANA.concat(['achari', 'cheddar', 'chettinad', 'korean']),
      big: ['almond-salted', 'almond-tandoori', 'cashew-salted', 'cashew-greenchilli', 'trail', 'trail-chilligarlic'] }
  ];
  function key(name) {
    var n = (name || '').toLowerCase();
    if (/panch\s*mewa/.test(n)) return 'panch-mewa';
    if (/almond/.test(n)) return /tandoori/.test(n) ? 'almond-tandoori' : (/salted/.test(n) ? 'almond-salted' : '');
    if (/cashew/.test(n)) return /green\s*chilli/.test(n) ? 'cashew-greenchilli' : /salted/.test(n) ? 'cashew-salted' : /peri\s*peri/.test(n) ? 'cashew-peri' : /italian/.test(n) ? 'cashew-italian' : '';
    if (/trail\s*mix/.test(n)) return /chilli|garlic/.test(n) ? 'trail-chilligarlic' : 'trail';
    if (/achari/.test(n)) return 'achari';
    if (/korean/.test(n)) return 'korean';
    if (/chettinad/.test(n)) return 'chettinad';
    if (/chees|cheddar/.test(n)) return 'cheddar';
    if (/himalayan|salt\s*&\s*pepper/.test(n)) return 'hsp';
    if (/\bbbq\b/.test(n)) return 'bbq';
    if (/italian/.test(n)) return 'italian';
    if (/peri\s*peri/.test(n)) return 'peri';
    if (/pudina/.test(n)) return 'pudina';
    return '';
  }
  function grams(t) { var m = /(\d+(?:\.\d+)?)\s*g\b/.exec(t || ''); return m ? parseFloat(m[1]) : 0; }
  function art(btn) {
    for (var c = 0; c < btn.children.length; c++) { var el = btn.children[c]; if (el.tagName === 'SPAN' && el.style.height === '66px') return el; }
    return null;
  }
  // Pack names. Text is changed on the existing text nodes so the page keeps managing them.
  function rename(box) {
    var btns = box.querySelectorAll('button[aria-label]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i], al = b.getAttribute('aria-label') || '';
      for (var n = 0; n < NAMES.length; n++) {
        if (al.indexOf(NAMES[n][0] + ' ') === 0) { b.setAttribute('aria-label', NAMES[n][1] + al.slice(NAMES[n][0].length)); break; }
      }
    }
    var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT), t, list = [];
    while ((t = walker.nextNode())) list.push(t);
    for (var j = 0; j < list.length; j++) {
      t = list[j];
      var d = t.data, s = d.trim();
      if (!s) continue;
      for (var m = 0; m < NAMES.length; m++) {
        var o = NAMES[m][0];
        if (s === o && t.parentNode && t.parentNode.closest && t.parentNode.closest('button')) { t.data = d.replace(o, NAMES[m][1]); break; }
        if (s.indexOf(o + ' · ') === 0) { t.data = d.replace(o + ' · ', NAMES[m][1] + ' · '); break; }
      }
    }
  }
  // Image attached in Shopify admin to the product's Pillow Pouch variant of this weight ('' when none).
  function variantImg(g) {
    var C = window.SnaccPdpCatalog, I = window.SnaccPdpInitial, c = C && I && C[I.fid];
    if (!c || !c.sizes) return '';
    for (var i = 0; i < c.sizes.length; i++) { var z = c.sizes[i]; if (z.type === 'sachet' && Number(z.grams) === g && z.img) return z.img; }
    return '';
  }
  function photos(box) {
    if (!BASE) return;
    var h1 = box.querySelector('h1'), k = key(h1 && h1.textContent);
    var sum = /Pillow Pouch\s*·\s*(\d+(?:\.\d+)?)\s*g\b/.exec(box.textContent || '');
    for (var p = 0; p < PHOTOS.length; p++) {
      var P = PHOTOS[p];
      var btns = box.querySelectorAll('button[aria-label^="' + P.name + ' "]');
      for (var i = 0; i < btns.length; i++) {
        var a = art(btns[i]); if (!a) continue;
        var list = P.keys, g = 0;
        if (P.big) {
          g = sum ? parseFloat(sum[1]) : grams(btns[i].getAttribute('aria-label').slice(P.name.length));
          list = !g ? P.keys.concat(P.big) : (g > 10 ? P.big : P.keys);
        }
        var has = k && list.indexOf(k) >= 0;
        var src = has ? BASE + P.prefix + k + '.webp' + V : '';
        var tag = P.prefix.replace(/^snacc-|-$/g, '') + '-' + k;
        // 21 g makhana Pillow Pouch: no theme photo, so the card shows that variant's own image from Shopify admin.
        if (!src && P.big && g > 10) { src = variantImg(g); tag = 'pillow-variant-' + g; }
        var img = a.querySelector(':scope > img.snacc-pack-img');
        if (!src) { if (img) img.remove(); a.removeAttribute('data-snacc-pack'); continue; }
        if (!img) { img = document.createElement('img'); img.className = 'snacc-pack-img'; img.alt = ''; img.setAttribute('aria-hidden', 'true'); a.appendChild(img); }
        if (img.getAttribute('src') !== src) img.setAttribute('src', src);
        if (a.getAttribute('data-snacc-pack') !== tag) a.setAttribute('data-snacc-pack', tag);
      }
    }
  }
  // Theme pack photo for a product (any name or handle) and pack title such as "60g Composite Jar"; '' when there is
  // none. Used by the product card pills below for packs that have no variant image in Shopify.
  window.SnaccPackPhoto = function (product, pack) {
    if (!BASE) return '';
    var k = key(String(product || '').replace(/-/g, ' ')), t = pack || '';
    for (var p = 0; p < PHOTOS.length; p++) {
      var P = PHOTOS[p];
      if (t.indexOf(P.name) < 0) continue;
      var list = P.big ? (grams(t) > 10 ? P.big : P.keys) : P.keys;
      return k && list.indexOf(k) >= 0 ? BASE + P.prefix + k + '.webp' + V : '';
    }
    return '';
  };
  var busy = false;
  function tick() {
    if (busy) return; busy = true;
    try {
      var boxes = document.querySelectorAll('[data-screen-label="02 Buy box"]');
      for (var b = 0; b < boxes.length; b++) { rename(boxes[b]); photos(boxes[b]); }
    } finally { busy = false; }
  }
  function start() {
    tick(); setInterval(tick, 300);
    if (window.MutationObserver) new MutationObserver(tick).observe(document.body, { subtree: true, childList: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Home page hero sticker (the starburst on the flavour slider): shows the price and size of the pack on screen
   (e.g. ₹149 · 50 g) instead of the fixed "₹10 minis", and follows the slider. The home page product card prices are
   corrected in snippets/snacc-product-images.liquid. */
(function () {
  var C = window.SnaccHomeCatalog, L = window.SnaccLiveProducts || {};
  if (!C) return;
  var V = {};
  for (var k in C) {
    var c = C[k], h = c && c.url ? String(c.url).split('/products/')[1] : '';
    h = h ? h.split(/[?#/]/)[0] : '';
    var lp = h && L[h];
    if (!lp || !lp.variants) continue;
    for (var i = 0; i < lp.variants.length; i++) {
      var v = lp.variants[i];
      if (String(v.id) === String(c.variant)) { V[k] = v; break; }
    }
  }
  var NAME = [[/\bbbq\b/i, 'bbq'], [/peri\s*peri/i, 'peri'], [/himalayan|salt\s*&\s*pepper/i, 'hsp'], [/italian/i, 'italian'], [/pudina/i, 'pudina']];
  function money(p) { return '₹' + (Math.round(p) === p ? p : p.toFixed(2)); }
  function size(t) { var m = /(\d+(?:\.\d+)?)\s*g\b/i.exec(t || ''); return m ? m[1] + ' g' : ''; }
  function tick() {
    var imgs = document.querySelectorAll('img[src*="snacc-pdp-v2-cc374b85017157ac"]');
    for (var i = 0; i < imgs.length; i++) {
      var st = imgs[i].parentElement, box = st && st.parentElement;
      if (!box || !st.lastElementChild || st.lastElementChild.children.length !== 2) continue;
      var slides = box.querySelectorAll('div[role="img"][aria-label]'), name = '';
      for (var s = 0; s < slides.length; s++) if (slides[s].style.opacity === '1') { name = slides[s].getAttribute('aria-label'); break; }
      if (!name) continue;
      var key = '';
      for (var n = 0; n < NAME.length; n++) if (NAME[n][0].test(name)) { key = NAME[n][1]; break; }
      var v = key && V[key];
      if (!v) continue;
      var a = st.lastElementChild.children[0], b = st.lastElementChild.children[1];
      var pt = money(v.price), sz = size(v.title);
      if (a.textContent !== pt) a.textContent = pt;
      if (sz && b.textContent !== sz) { b.textContent = sz; b.style.textTransform = 'none'; }
    }
  }
  // The hero is drawn by the page script after this file runs, so keep checking.
  function start() { tick(); setInterval(tick, 300); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Product cards (home page shelves and collection pages): a "Pack" row under the product name with one pill per pack
   of that product (the Shopify option "Pack Size", e.g. 50g Standy, 60g Composite Jar, 6g Pillow Pouch). The pill of
   the pack the card sells is selected to start with. Tapping another pill shows that pack's photo (the variant's own
   image in Shopify admin; packs without one use the theme's pack photo), puts its price on the price sticker, and the
   card's add button then adds that pack. Packs that are sold out have a dashed outline. The price sticker always shows
   the selected pack's price. Data: snippets/snacc-card-variants.liquid. */
(function () {
  var D = window.SnaccCardVariants;
  if (!D) return;
  var chosen = {}, pending = false;
  // One line under the name; when the pills don't fit they scroll sideways and the cut-off edge fades out.
  var css = '.snacc-packs{display:flex;align-items:center;gap:4px;min-width:0;max-width:calc(100% + 4px);contain:inline-size;margin:0 -2px;padding:3px 2px 4px 4px;overflow-x:auto;overscroll-behavior-x:contain;scrollbar-width:none;-webkit-overflow-scrolling:touch}' +
    '.snacc-packs::-webkit-scrollbar{display:none}' +
    '.snacc-packs[data-more="end"]{-webkit-mask:linear-gradient(90deg,#000 calc(100% - 18px),transparent);mask:linear-gradient(90deg,#000 calc(100% - 18px),transparent)}' +
    '.snacc-packs[data-more="both"]{-webkit-mask:linear-gradient(90deg,transparent,#000 18px,#000 calc(100% - 18px),transparent);mask:linear-gradient(90deg,transparent,#000 18px,#000 calc(100% - 18px),transparent)}' +
    '.snacc-packs[data-more="start"]{-webkit-mask:linear-gradient(90deg,transparent,#000 18px);mask:linear-gradient(90deg,transparent,#000 18px)}' +
    // The page styles every button with font:inherit, so the pill rules are scoped under .snacc-packs and pinned.
    '.snacc-packs .snacc-packs__k{flex:none;font-size:8px!important;font-weight:800!important;line-height:1!important;letter-spacing:.14em!important;text-transform:uppercase;color:#5C544C;margin-right:2px}' +
    '.snacc-packs .snacc-pill{flex:none;display:inline-flex!important;align-items:center;justify-content:center;box-sizing:border-box!important;height:22px!important;min-height:0!important;width:auto!important;min-width:0!important;margin:0!important;padding:0 8px!important;' +
    'font-family:inherit!important;font-size:9.5px!important;font-weight:800!important;font-style:normal!important;line-height:1!important;letter-spacing:.01em!important;text-transform:none!important;white-space:nowrap;' +
    'color:#1E1C1A;background:transparent;border:1.5px solid #1E1C1A!important;border-radius:99px!important;box-shadow:none;cursor:pointer;-webkit-appearance:none;appearance:none;transition:background .15s,transform .15s}' +
    '.snacc-packs .snacc-pill[aria-pressed="true"]{background:#FDB716;box-shadow:-1.5px 1.5px 0 #1E1C1A}' +
    '.snacc-packs .snacc-pill[data-off]{border-style:dashed!important;color:#7A7168}' +
    '.snacc-packs .snacc-pill[data-off][aria-pressed="true"]{color:#1E1C1A}' +
    '.snacc-packs .snacc-pill:active{transform:scale(.94)}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function handleOf(card) {
    var a = card.querySelector('h3 a[href*="/products/"]');
    var m = a && /\/products\/([^/?#]+)/.exec(a.getAttribute('href') || '');
    return m ? decodeURIComponent(m[1]) : '';
  }
  // The pack the card sells by default: the variant the page's own add button adds.
  function defaultId(h, list) {
    var c = window.SnaccCollectionProducts || [], i;
    for (i = 0; i < c.length; i++) if (c[i].handle === h && c[i].variant) return c[i].variant;
    var H = window.SnaccHomeCatalog || {};
    for (var k in H) if (H[k] && H[k].variant && /\/products\/([^/?#]+)/.test(H[k].url || '') && /\/products\/([^/?#]+)/.exec(H[k].url)[1] === h) return H[k].variant;
    for (i = 0; i < list.length; i++) if (list[i].a) return list[i].id;
    return list[0].id;
  }
  function find(list, id) { for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(id)) return list[i]; return null; }
  function grams(t) { var m = /(\d+(?:\.\d+)?)\s*g\b/i.exec(t || ''); return m ? m[1] + ' g' : ''; }
  function remember(el, prop, val) {
    var a = 'data-snacc-' + prop;
    if (val == null) { if (el.hasAttribute(a)) { set(el, prop, el.getAttribute(a)); el.removeAttribute(a); } return; }
    if (!el.hasAttribute(a)) el.setAttribute(a, get(el, prop));
    set(el, prop, val);
  }
  function get(el, prop) { return prop === 'bg' ? el.style.backgroundImage : el.textContent; }
  function set(el, prop, v) {
    if (prop === 'bg') { if (el.style.backgroundImage !== v) el.style.backgroundImage = v; }
    else if (el.textContent !== v) el.textContent = v;
  }
  function textNode(el) {
    for (var n = el.firstChild; n; n = n.nextSibling) if (n.nodeType === 3 && n.data.trim()) return n;
    return null;
  }
  function addButton(card) { var b = card.querySelectorAll('button:not(.snacc-pill)'); return b.length ? b[b.length - 1] : null; }
  function lastText(el) { var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n, last = null; while ((n = w.nextNode())) if (n.data.trim()) last = n; return last; }
  function render(card) {
    var h = handleOf(card), list = h && D[h];
    if (!list || !list.length) { var old = card.querySelector('.snacc-packs'); if (old) old.remove(); return; }
    // The page reuses cards when a shelf filter changes; forget what was remembered for the previous product.
    if (card.getAttribute('data-snacc-card') !== h) {
      var kept = card.querySelectorAll('[data-snacc-bg],[data-snacc-txt]');
      for (var q = 0; q < kept.length; q++) { kept[q].removeAttribute('data-snacc-bg'); kept[q].removeAttribute('data-snacc-txt'); }
      var ab = addButton(card); if (ab) ab.removeAttribute('data-snacc-label');
      card.setAttribute('data-snacc-card', h);
    }
    var h3 = card.querySelector('h3'), def = defaultId(h, list), id = chosen[h] || def, v = find(list, id) || find(list, def);
    if (!v) return;
    // pills
    var row = h3.nextElementSibling;
    if (!row || !row.classList.contains('snacc-packs') || row.getAttribute('data-h') !== h) {
      if (row && row.classList.contains('snacc-packs')) row.remove();
      row = document.createElement('div'); row.className = 'snacc-packs'; row.setAttribute('data-h', h);
      row.setAttribute('role', 'group'); row.setAttribute('aria-label', 'Pack');
      var k = document.createElement('span'); k.className = 'snacc-packs__k'; k.textContent = 'Pack'; row.appendChild(k);
      list.forEach(function (x) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'snacc-pill'; b.textContent = x.t;
        b.setAttribute('data-id', x.id); if (!x.a) { b.setAttribute('data-off', ''); b.title = 'Sold out'; }
        row.appendChild(b);
      });
      h3.parentNode.insertBefore(row, h3.nextSibling);
    }
    var pills = row.querySelectorAll('.snacc-pill');
    for (var i = 0; i < pills.length; i++) {
      var on = pills[i].getAttribute('data-id') === String(v.id) ? 'true' : 'false';
      if (pills[i].getAttribute('aria-pressed') !== on) pills[i].setAttribute('aria-pressed', on);
    }
    fade(row);
    var isDef = String(v.id) === String(def);
    // photo
    var front = card.querySelector('div[role="img"][aria-label$=", front"]') || card.querySelector('div[role="img"]');
    if (front) {
      var url = isDef ? '' : (v.img || (window.SnaccPackPhoto ? window.SnaccPackPhoto(h, v.t) : ''));
      remember(front, 'bg', url ? 'url("' + url + '")' : null);
    }
    // price sticker
    var sticker = card.querySelector('img[src*="snacc-pdp-v2-1e8c60bf5019c380"]'), label = sticker && sticker.nextElementSibling;
    var tn = label && textNode(label), price = '₹' + (Math.round(v.p) === v.p ? v.p : v.p.toFixed(2));
    if (tn && tn.data !== price) tn.data = price;
    // add button says SOLD OUT while a sold-out pack is picked
    var add = addButton(card), ln = add && lastText(add);
    if (ln) {
      if (!isDef && !v.a) { if (!add.hasAttribute('data-snacc-label')) add.setAttribute('data-snacc-label', ln.data); if (ln.data !== 'SOLD OUT') ln.data = 'SOLD OUT'; }
      else if (add.hasAttribute('data-snacc-label')) { if (ln.data === 'SOLD OUT') ln.data = add.getAttribute('data-snacc-label'); add.removeAttribute('data-snacc-label'); }
    }
    // weight row ("Net wt" / "Pack size")
    var rows = card.querySelectorAll('h3 ~ div');
    for (var r = 0; r < rows.length; r++) {
      var sp = rows[r].children;
      if (sp.length === 2 && /^(net wt|pack size)$/i.test((sp[0].textContent || '').trim())) remember(sp[1], 'txt', isDef ? null : (grams(v.t) || null));
    }
  }
  function fade(row) {
    var max = row.scrollWidth - row.clientWidth, x = row.scrollLeft;
    var m = max <= 1 ? '' : (x <= 1 ? 'end' : (x >= max - 1 ? 'start' : 'both'));
    if ((row.getAttribute('data-more') || '') !== m) { if (m) row.setAttribute('data-more', m); else row.removeAttribute('data-more'); }
  }
  document.addEventListener('scroll', function (e) { var t = e.target; if (t && t.classList && t.classList.contains('snacc-packs')) fade(t); }, true);
  function all() { var cards = document.querySelectorAll('article'); for (var i = 0; i < cards.length; i++) render(cards[i]); }

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    var pill = t.closest('.snacc-pill');
    if (pill) {
      e.preventDefault(); e.stopPropagation();
      var row = pill.closest('.snacc-packs'); chosen[row.getAttribute('data-h')] = pill.getAttribute('data-id');
      all();
      var l = pill.offsetLeft - row.offsetLeft, r = l + pill.offsetWidth;
      if (row.scrollTo && (l < row.scrollLeft + 20 || r > row.scrollLeft + row.clientWidth - 20)) row.scrollTo({ left: Math.max(0, l - 30), behavior: 'smooth' });
      return;
    }
    // Add button of a card showing a pack other than its default: add the chosen pack.
    var btn = t.closest('article button'), card = btn && btn.closest('article'), h = card && handleOf(card), list = h && D[h];
    if (!list || !chosen[h] || btn !== addButton(card)) return;
    var def = defaultId(h, list), v = find(list, chosen[h]);
    if (!v || String(v.id) === String(def)) return;
    e.preventDefault(); e.stopPropagation();
    var tn = lastText(btn);
    var was = tn && tn.data;
    function flash(msg) { if (!tn) return; tn.data = msg; setTimeout(function () { if (tn.data === msg) tn.data = was; }, 1600); }
    if (!v.a) { flash('SOLD OUT'); return; }
    if (pending) return; pending = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(v.id), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error(); return fetch(root + 'cart.js').then(function (x) { return x.json(); }); })
      .then(function (cart) { flash('IN THE BAG ✓'); document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } })); })
      .catch(function () { flash('TRY AGAIN'); })
      .then(function () { pending = false; });
  }, true);

  var queued = false;
  function soon() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; all(); }); }
  function start() {
    all(); setInterval(all, 1000);
    if (window.MutationObserver) new MutationObserver(soon).observe(document.body, { subtree: true, childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
